import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

const teamMembers = [
  {
    name: 'Dato\' Ahmad Rizal bin Mahathir',
    role: 'Chief Executive Officer',
    experience: '25 years in travel industry',
    image: 'https://public.readdy.ai/ai/img_res/d66e564897c4c25cb8fc64a526cd5909.jpg',
  },
  {
    name: 'Ms. Linda Tan Siew Ling',
    role: 'General Manager, Operations',
    experience: '18 years in tourism management',
    image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20Malaysian%20Chinese%20woman%20in%20her%2040s%20wearing%20blazer%2C%20warm%20smile%2C%20clean%20bright%20background%2C%20corporate%20headshot%20photography&width=300&height=340&seq=5002&orientation=portrait',
  },
  {
    name: 'Mr. Suresh A/L Krishnan',
    role: 'Head of Tour Development',
    experience: '15 years designing tour packages',
    image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20Malaysian%20Indian%20man%20in%20his%2040s%20wearing%20smart%20casual%20shirt%2C%20friendly%20smile%2C%20bright%20clean%20background%2C%20corporate%20headshot&width=300&height=340&seq=5003&orientation=portrait',
  },
  {
    name: 'Ms. Nur Fazrina binti Azhar',
    role: 'Head of Customer Experience',
    experience: '12 years in customer relations',
    image: 'https://readdy.ai/api/search-image?query=professional%20portrait%20of%20a%20Malaysian%20Malay%20woman%20wearing%20hijab%20in%20her%2030s%2C%20warm%20professional%20smile%2C%20bright%20studio%20background%2C%20corporate%20headshot%20photography&width=300&height=340&seq=5004&orientation=portrait',
  },
];

const milestones = [
  { year: '2008', event: 'Founded in Kuala Lumpur with a team of 5 dedicated travel enthusiasts. Obtained MATTA membership and officially licensed by Ministry of Tourism Malaysia.' },
  { year: '2011', event: 'Expanded to East Asia packages — Japan, Korea, and China become top sellers.' },
  { year: '2015', event: 'Crossed the milestone of 5,000 satisfied travellers and opened our second branch in Penang.' },
  { year: '2018', event: 'Launched premium Europe and Middle East tour packages. IATA accreditation achieved.' },
  { year: '2020', event: 'Resilient through the pandemic — pivoted to domestic packages and emerged stronger.' },
  { year: '2023', event: 'Celebrated 10,000+ happy travellers and launched our new digital booking platform.' },
  { year: '2025', event: 'Surpassed 20,000 happy travellers and expanded to 50+ worldwide destinations.' },
];

export default function AboutPage() {
  return (
    <div>
      <Navbar />

      {/* Hero */}
      <section className="relative h-80 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=professional%20Malaysian%20travel%20agency%20team%20meeting%20with%20world%20map%20and%20travel%20brochures%20modern%20office%20conference%20room%2C%20diverse%20team%20smiling%2C%20bright%20corporate%20environment&width=1920&height=450&seq=5010&orientation=landscape"
          alt="About Us"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-emerald-900/72"></div>
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center px-6 pt-20">
          <p className="text-amber-400 text-sm font-semibold uppercase tracking-widest mb-3">Our Story</p>
          <h1 className="text-4xl md:text-5xl font-bold text-white font-playfair">About Arus Travel & Tours</h1>
          <p className="text-white/75 mt-3 text-base max-w-xl">
            Over 17 years of crafting extraordinary journeys for Malaysian travellers worldwide.
          </p>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="text-amber-500 font-semibold text-sm uppercase tracking-widest mb-4">Who We Are</p>
              <h2 className="text-4xl font-bold text-gray-900 font-playfair mb-6">
                Malaysia's Trusted Travel Partner Since 2008
              </h2>
              <p className="text-gray-600 text-base leading-relaxed mb-5">
                Arus Travel & Tours Sdn Bhd was founded in 2008 with a singular vision: to make quality world travel accessible to every Malaysian family. What began as a small team of five passionate travel enthusiasts in Kuala Lumpur has grown into one of Malaysia's most trusted and beloved travel agencies.
              </p>
              <p className="text-gray-600 text-base leading-relaxed mb-5">
                Over 17 years, we have crafted unforgettable journeys for more than 20,000 happy travellers, taking them to breathtaking destinations across Southeast Asia, East Asia, Europe, the Middle East, and the Indian Ocean.
              </p>
              <p className="text-gray-600 text-base leading-relaxed mb-8">
                As a fully licensed MOT travel agency and proud member of MATTA and IATA, we are committed to the highest standards of service, safety, and value. Every tour we design is a reflection of our passion for travel and our deep care for our clients.
              </p>
              <div className="flex flex-wrap gap-4">
                {['MOT Licensed', 'MATTA Member', 'IATA Accredited', 'Tourism Malaysia Partner'].map((cert) => (
                  <div key={cert} className="flex items-center gap-2 bg-emerald-50 px-4 py-2 rounded-full">
                    <div className="w-4 h-4 flex items-center justify-center text-emerald-600 flex-shrink-0">
                      <i className="ri-verified-badge-fill text-sm"></i>
                    </div>
                    <span className="text-emerald-800 text-xs font-semibold">{cert}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative">
              <div className="w-full h-96 rounded-xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=modern%20travel%20agency%20office%20in%20Malaysia%20with%20globe%20display%20world%20maps%20and%20brochures%20warm%20interior%20lighting%2C%20welcoming%20professional%20environment%2C%20reception%20area&width=700&height=500&seq=5011&orientation=landscape"
                  alt="Our office"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute -bottom-5 -left-5 bg-amber-500 text-white rounded-xl px-6 py-5">
                <p className="text-3xl font-bold font-playfair">17+</p>
                <p className="text-sm font-medium text-amber-100">Years of Excellence</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-14">
            <p className="text-amber-500 font-semibold text-sm uppercase tracking-widest mb-3">What Drives Us</p>
            <h2 className="text-4xl font-bold text-gray-900 font-playfair">Our Mission & Vision</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-8 border border-gray-100 text-center">
              <div className="w-14 h-14 flex items-center justify-center bg-amber-100 rounded-xl mx-auto mb-5">
                <i className="ri-compass-3-line text-2xl text-amber-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 font-playfair mb-4">Our Mission</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                To create extraordinary travel experiences that inspire, connect, and transform lives — delivering unmatched value, comfort, and care in every journey we craft.
              </p>
            </div>
            <div className="bg-emerald-700 rounded-xl p-8 text-center">
              <div className="w-14 h-14 flex items-center justify-center bg-white/20 rounded-xl mx-auto mb-5">
                <i className="ri-eye-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-white font-playfair mb-4">Our Vision</h3>
              <p className="text-white/85 text-sm leading-relaxed">
                To be Malaysia's most trusted and innovative travel company, recognised for excellence in service and our commitment to making the world accessible to every Malaysian.
              </p>
            </div>
            <div className="bg-white rounded-xl p-8 border border-gray-100 text-center">
              <div className="w-14 h-14 flex items-center justify-center bg-emerald-100 rounded-xl mx-auto mb-5">
                <i className="ri-heart-3-line text-2xl text-emerald-700"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 font-playfair mb-4">Our Values</h3>
              <p className="text-gray-500 text-sm leading-relaxed">
                Integrity, excellence, and genuine care for every traveller. We believe every person deserves to experience the world's wonders with confidence and joy.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Timeline */}
      <section className="py-20 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="text-center mb-14">
            <p className="text-amber-500 font-semibold text-sm uppercase tracking-widest mb-3">Our Journey</p>
            <h2 className="text-4xl font-bold text-gray-900 font-playfair">Company Milestones</h2>
          </div>
          <div className="relative">
            <div className="absolute left-1/2 -translate-x-1/2 top-0 bottom-0 w-0.5 bg-emerald-100"></div>
            <div className="space-y-8">
              {milestones.map((m, idx) => (
                <div
                  key={m.year}
                  className={`flex items-center gap-8 ${idx % 2 === 0 ? 'flex-row' : 'flex-row-reverse'}`}
                >
                  <div className={`flex-1 ${idx % 2 === 0 ? 'text-right' : 'text-left'}`}>
                    <div className={`inline-block bg-white border border-gray-100 rounded-xl p-5 max-w-xs ${idx % 2 === 0 ? 'ml-auto' : 'mr-auto'}`}>
                      <p className="text-emerald-700 font-bold text-sm mb-1">{m.year}</p>
                      <p className="text-gray-600 text-sm leading-relaxed">{m.event}</p>
                    </div>
                  </div>
                  <div className="w-10 h-10 flex items-center justify-center bg-emerald-700 rounded-full text-white font-bold text-xs z-10 flex-shrink-0">
                    {m.year.slice(2)}
                  </div>
                  <div className="flex-1"></div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Team */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-14">
            <p className="text-amber-500 font-semibold text-sm uppercase tracking-widest mb-3">The People Behind</p>
            <h2 className="text-4xl font-bold text-gray-900 font-playfair mb-4">Meet Our Leadership Team</h2>
            <p className="text-gray-500 text-base max-w-xl mx-auto">
              A passionate and experienced team dedicated to delivering the best travel experiences for you.
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-7">
            {teamMembers.map((member) => (
              <div key={member.name} className="group bg-white rounded-xl overflow-hidden border border-gray-100 hover:border-emerald-200 transition-all duration-300 text-center">
                <div className="w-full h-64 overflow-hidden">
                  <img
                    src={member.image}
                    alt={member.name}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="p-5">
                  <h3 className="font-bold text-gray-900 text-base font-playfair mb-1">{member.name}</h3>
                  <p className="text-emerald-700 text-sm font-medium mb-2">{member.role}</p>
                  <p className="text-gray-400 text-xs">{member.experience}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
